var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57141 7.25016C6.57141 5.67615 7.78664 4.40025 9.2857 4.40025L10.1905 4.40025L10.1905 3.44997C10.1905 3.27698 10.2345 3.11472 10.3115 2.97498C10.4679 2.69104 10.7604 2.5 11.0952 2.5L12.9047 2.5C13.2396 2.5 13.532 2.69104 13.6884 2.97498C13.7654 3.11472 13.8095 3.27698 13.8095 3.44997L13.8095 4.40025L14.7143 4.40025C16.2134 4.40025 17.4286 5.67615 17.4286 7.25015L17.4286 18.6501C17.4286 20.224 16.2134 21.5 14.7143 21.5L9.2857 21.5C7.78664 21.5 6.57141 20.224 6.57141 18.6501L6.57141 7.25016ZM9.2857 11.05L9.2857 17.7001C9.2857 18.2248 9.69078 18.6501 10.1905 18.6501L13.8095 18.6501C14.3092 18.6501 14.7143 18.2248 14.7143 17.7001L14.7143 11.05C14.7143 10.5254 14.3092 10.1001 13.8095 10.1001L10.1905 10.1001C9.69078 10.1001 9.2857 10.5254 9.2857 11.05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon-battery.4dabfb02743bc408bd0f1bacbbc834f3.svg";
export { ForwardRef as ReactComponent };